import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { message } from 'antd'
import ErrorModal from './modal/ErrorModal'

const ModuleAssessment = ({ navigate }) => {
  const location = useLocation()

  const moduleId = location.state?.moduleId || location.state
  const userId = useSelector(state => state.user.user?.data.id)

  const [questions, setQuestions] = useState([])
  const [selectedAnswers, setSelectedAnswers] = useState([])
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
  const [showResult, setShowResult] = useState(false)
  const [isCorrect, setIsCorrect] = useState(null)
  const [isForceModalOpen, setForceModalOpen] = useState(false)
  const [clickNext, setClickNext] = useState(false)

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await axios.post('/api/module/fetchQuestion', {
          moduleId
        })
        setQuestions(response.data.data)
        // console.log(response)
      } catch (error) {
        console.error('Error fetching questions:', error)
        setQuestions([])
      }
    }

    if (moduleId) {
      fetchQuestions()
    }
  }, [moduleId])

  const handleAnswerChange = event => {
    const answerId = event.target.value
    const isSelected = selectedAnswers.includes(answerId)

    if (isSelected) {
      setSelectedAnswers(prevSelectedAnswers =>
        prevSelectedAnswers.filter(id => id !== answerId)
      )
    } else {
      setSelectedAnswers(prevSelectedAnswers => [
        ...prevSelectedAnswers,
        answerId
      ])
    }

    setShowResult(false)
  }

  // console.log('userId ----', userId)

  const handleNext = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(prevIndex => prevIndex + 1)
      setSelectedAnswers([])
      setShowResult(false)
    } else {
      if (!userId) {
        message.error('Please login to continue')
        setTimeout(() => {
          navigate('/login')
        }, 2000)
      }
      const updateAssessment = async () => {
        try {
          const response = await axios.post(
            '/api/module/updateAssessmentStatus',
            {
              moduleId,
              userId
            }
          )
          if (response.status === 200) {
            window.location.reload() // Refresh the page
          } else {
            console.log('Failed to update assessment status')
          }
        } catch (error) {
          console.error('Error updating assessment status:', error)
        }
      }

      updateAssessment()
    }
  }

  const handleSubmit = () => {
    const currentQuestion = questions[currentQuestionIndex]
    const correctAnswerIds = currentQuestion.Answers.filter(
      answer => answer.correctAnswer === '1'
    ).map(answer => answer.id)

    const isAnswerCorrect =
      correctAnswerIds.length === selectedAnswers.length &&
      correctAnswerIds.every(id => selectedAnswers.includes(id))

    setIsCorrect(isAnswerCorrect)
    setShowResult(true)

    if (isAnswerCorrect) {
      setIsCorrect(null)
      setShowResult(false)
      handleNext()
    }
  }

  useEffect(() => {
    if (isCorrect === false) {
      setForceModalOpen(true)
    }
    setClickNext(false)
  }, [isCorrect, clickNext])

  // console.log('questions', questions)

  return (
    <div className="video">
      <ErrorModal
        isOpen={isForceModalOpen}
        onClose={() => setForceModalOpen(false)}
      />

      <div className="assessment-container">
        <div style={{ padding: '50px' }}>
          {Array.isArray(questions) &&
            questions.length > 0 &&
            currentQuestionIndex < questions.length && (
              <div key={questions[currentQuestionIndex].id}>
                {questions[currentQuestionIndex].id === '197d9a72-fab4-4856-a0aa-b4232c933eca' && <section className='mb-4'>
                  <h5>Case Scenario Child M </h5>
                  <div>
                    <p>Child M is a 3-year-old boy who was recently admitted for acute gastroenteritis (AGE) with 8% dehydration. He has no known underlying medical conditions.</p> 
                    <p>Prior to admission, his best recorded weight was 10.5 kg, which falls between -2 to -3 SD for age. His length was 85 cm (-2 SD), indicating growth concerns.</p> 
                    <p>Dietary history revealed that Child M had stopped breastfeeding and was not receiving any regular milk or formula feeds. His mother expressed concern regarding his solid food intake and reported that he tends to eat better when spoon-fed. </p> 
                    <p>His usual meals consist of rice mixed with soup or gravy, along with small pieces of chicken. However, he is often unable to finish more than one scoop (approximately ½ cup) of rice. His mother noted that he has a better appetite when offered pasta or noodles instead. </p> 
                    The mother described him as very active at home and stated that he frequently continues playing during mealtimes. To encourage eating, she allows him to watch television, which helps settle him and enables her to spoon-feed him within approximately 30 minutes before the family dinner time.Which of the following statement is true about this case scenario? 
                  </div>
                </section>}
                <div className="d-flex">
                  <div>{`${currentQuestionIndex + 1}.`}</div>
                  <div className="ms-2">
                    {questions[currentQuestionIndex].question}
                  </div>
                </div>
                <div className="mt-3 ms-3">
                  {Array.isArray(questions[currentQuestionIndex].Answers) &&
                    questions[currentQuestionIndex].Answers.map(answer => (
                      <div key={answer.id} className="mb-3">
                        <label className="d-flex">
                          <input
                            type="checkbox"
                            value={answer.id}
                            checked={selectedAnswers.includes(answer.id)}
                            onChange={handleAnswerChange}
                            className="mt-1 me-2 align-self-start"
                          />
                          {answer.answer}
                        </label>
                      </div>
                    ))}
                </div>
                {showResult && (
                  <p style={{ color: isCorrect ? 'green' : 'red' }}>
                    {isCorrect
                      ? 'Correct answer! Moving to the next question.'
                      : ''}
                  </p>
                )}
                <div className="text-center">
                  <button
                    className="sm-rounded-button"
                    style={{ padding: '8px 50px' }}
                    onClick={() => {
                      setClickNext(true)
                      if (isCorrect) {
                        handleNext()
                      } else {
                        handleSubmit()
                      }
                    }}
                  >
                    {currentQuestionIndex < questions.length - 1
                      ? 'Next'
                      : 'Submit'}
                  </button>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  )
}

export default ModuleAssessment
